import React from "react";
const TicketVideo = ({ driveId }) => {
	const url = `https://drive.google.com/file/d/${driveId}/preview`;

	return (
		<div
			style={{
				position: "relative",
				width: "100%",
				height: "auto",
				// 16:9 ratio = 9/16 = 56.25%
				paddingBottom: "56.25%",
				margin: "0 auto",
			}}
		>
			<iframe
				title="Ticket Video"
				src={url}
				allow="encrypted-media"
				allowFullScreen
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					border: "none",
					width: "100%",
					height: "100%",
				}}
			/>
		</div>
	);
};

export default TicketVideo;
